import Api from "./api";

class CrmService {
    api = new Api();

    getBuying(buyingId, buyingType) {
        return this.api.get('/admin/crm/get-buying', {
            buyingId: buyingId,
            buyingType: buyingType
        })
    }

    setBuyingAccountManager(buyingId, buyingType, filter) {
        return this.api.post('/admin/crm/set-buying-account-manager', {
            buyingId: buyingId,
            buyingType: buyingType,
            filter: filter
        });
    }

    sendHistoryEntity(entityType, entityId, actionData) {
        return this.api.post('/admin/crm/send-history-entity', {
            entityType: entityType,
            entityId: entityId,
            actionData: actionData
        });
    }

    editHistoryComment(actionId, actionData) {
        return this.api.post('/admin/crm/edit-history-comment', {
            actionId: actionId,
            actionData: actionData,
        });
    }

    deleteHistoryEntity(actionId) {
        return this.api.post('/admin/crm/delete-history-entity', {
            actionId: actionId,
        });
    }

    getUser(userId) {
        return this.api.get('/admin/crm/get-user', {
            userId: userId
        });
    }

    changeUserRole(userId, role) {
        return this.api.post('/admin/crm/change-user-role', {
            userId: userId,
            role: role
        });
    }

    sendScore(file) {
        return this.api.postFile('/admin/crm/send-score', file);
    }

    attachDocumentToBuying(buyingId, buyingType, documentId, documentType) {
        return this.api.post('/admin/crm/attach-document-to-buying', {
            buyingId: buyingId,
            buyingType: buyingType,
            documentId: documentId,
            documentType: documentType
        });
    }

    detachDocumentToBuying(documentId, documentType) {
        return this.api.post('/admin/crm/detach-document-to-buying', {
            documentId: documentId,
            documentType: documentType,
        });
    }

    deleteUserDocument(documentId) {
        return this.api.post('/admin/crm/delete-user-document', {
            documentId: documentId,
        });
    }

    changeStatusPayment(paymentId, status, comment) {
        return this.api.post('/admin/crm/change-status-payment', {
            paymentId: paymentId,
            status: status,
            comment: comment,
        });
    }

    changeUserMoney(userId, money) {
        return this.api.post('/admin/crm/change-user-money', {
            userId: userId,
            money: money,
        });
    }


}

export default new CrmService();